import { render, staticRenderFns } from "./debris.vue?vue&type=template&id=11c2183f&scoped=true"
import script from "./debris.vue?vue&type=script&lang=js"
export * from "./debris.vue?vue&type=script&lang=js"
import style0 from "./debris.vue?vue&type=style&index=0&id=11c2183f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c2183f",
  null
  
)

export default component.exports